import { http } from 'connex-cds';

export default {
  searchBillables: ({ entityRef, date }) =>
    http.get({ apiName: 'billing-exp', path: `/${entityRef}/billables/?dateOption=${date}&timeZone=UTC-4` }),
};
